var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInformationIcon = function SvgInformationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.904 10.75V7.5",
    stroke: "#85724C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.904 4.25c-.636 0-1.15.484-1.15 1.083 0 .598.514 1.083 1.15 1.083.635 0 1.15-.485 1.15-1.083 0-.599-.515-1.084-1.15-1.084Z",
    fill: "#85724C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.904 14c3.813 0 6.903-2.91 6.903-6.5S11.717 1 7.904 1C4.09 1 1 3.91 1 7.5S4.09 14 7.904 14Z",
    stroke: "#85724C"
  })));
};

export default SvgInformationIcon;